(function () {
  'use strict';

  // URL storefront config промо-додатку
  var CONFIG_URL      = 'https://poland.bibliotheque-de-parfum.ca/storefront/config';
  var SAVINGS_LINE_ID = 'promo-app-savings-line';

  var cachedConfig  = null;
  var debounceTimer = null;

  // ── Логіка відбору (дзеркало Shopify Function) ─────────────────────────────

  function isQualifying(item, appliesTo, ids, typeEq, typeCont, allowDiscounted) {
    if (!allowDiscounted && item.compare_at_price && item.compare_at_price > item.price) return false;
    if (appliesTo === 'all') return true;
    if (appliesTo === 'product_type') {
      var pt = (item.product_type || '').trim();
      if ((typeEq   || []).some(function (t) { return t === pt; })) return true;
      if ((typeCont || []).some(function (t) { return pt.indexOf(t) !== -1; })) return true;
      return false;
    }
    // 'products' або legacy 'collections'
    var numIds = (ids || []).map(function (g) { return String(g).split('/').pop(); });
    return numIds.indexOf(String(item.product_id)) !== -1;
  }

  function calcPromo(promo, items) {
    var triggerQty = items
      .filter(function (i) {
        return isQualifying(i,
          promo.applies_to, promo.product_ids,
          promo.product_type_equals, promo.product_type_contains,
          promo.applies_to_discounted);
      })
      .reduce(function (s, i) { return s + i.quantity; }, 0);

    if (triggerQty < (promo.min_quantity || 3)) return null;

    var gifts = items.filter(function (i) {
      return isQualifying(i,
        promo.gift_applies_to, promo.gift_product_ids,
        promo.gift_product_type_equals, promo.gift_product_type_contains,
        promo.applies_to_discounted);
    });
    if (!gifts.length) return null;

    gifts.sort(function (a, b) { return a.price - b.price; });
    var cheapest = gifts[0];
    if (!cheapest || cheapest.price <= 0) return null;

    // Повертаємо variant id cheapest item для виключення з base savings
    // Використовуємо id (не key), бо variant_id однаковий і в Liquid (data-id) і в /cart.js
    return { cents: cheapest.price, name: promo.name || '3ZA2', giftId: String(cheapest.id) };
  }

  // ── Форматування грошей ─────────────────────────────────────────────────────

  function money(cents) {
    var amount   = cents / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
    // Читаємо локаль зі сторінки; якщо 'en' — для PLN форматуємо як польська ('pl')
    var lang = (document.documentElement.lang || '').toLowerCase();
    var locale = (lang && lang !== 'en') ? lang : (currency === 'PLN' ? 'pl' : 'en');
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency,
      }).format(amount);
    } catch (_) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  // ── DOM: рядок загальної знижки (savings) ──────────────────────────────────

  // ── Знижки з compare_at_price (Liquid-сумісна формула) ─────────────────────

  function calcBaseSavings(excludeId) {
    // Читаємо savings прямо з DOM — Liquid вже порахував точну суму (data-savings-cents)
    // excludeId: variant id gift item (data-id) — надійніше ніж key (key може відрізнятись)
    var section = document.getElementById('shopify-section-quick-cart');
    if (!section) return 0;
    var itemEls = section.querySelectorAll('[data-input-item][data-id]');
    var sum = 0;
    itemEls.forEach(function (el) {
      if (excludeId && el.getAttribute('data-id') === excludeId) return; // пропускаємо gift item
      var savings = parseInt(el.getAttribute('data-savings-cents') || '0', 10);
      if (savings > 0) sum += savings;
    });
    return sum;
  }

  function getSavingsLabel() {
    var cartEl = document.querySelector('#shopify-section-quick-cart .quick-cart');
    return (cartEl && cartEl.getAttribute('data-savings-label')) || 'Savings';
  }

  function getPromoNote() {
    var cartEl = document.querySelector('#shopify-section-quick-cart .quick-cart');
    return (cartEl && cartEl.getAttribute('data-promo-note')) || 'incl. promo';
  }

  function updateSavingsRow(footerInner, promoResult) {
    var old = document.getElementById(SAVINGS_LINE_ID);
    if (old) old.remove();

    var promoCents = promoResult ? promoResult.cents : 0;
    var giftId     = promoResult ? promoResult.giftId : null;

    // Base savings з DOM (data-savings-cents) — Liquid-точність, оновлюється після AJAX
    var baseCents  = calcBaseSavings(giftId);
    var totalCents = baseCents + promoCents;

    // Приховуємо Liquid-рядок (може мати застарілу суму після AJAX)
    var liquidEl = footerInner.querySelector('[data-liquid-savings]');
    if (liquidEl) liquidEl.style.display = 'none';

    if (totalCents <= 0) return;

    // Promo indicator: маленький підпис з назвою промо
    var promoNote = promoResult
      ? '<span style="font-size:11px;opacity:0.6;display:block;margin-top:2px;font-weight:400">' + promoResult.name + '</span>'
      : '';

    var div = document.createElement('div');
    div.id        = SAVINGS_LINE_ID;
    div.className = 'quick-cart__footer-savings';
    div.style.cssText = 'display:flex';
    div.innerHTML =
      '<h3 class="ff-body fs-body-150">' + getSavingsLabel() + promoNote + '</h3>' +
      '<span class="ff-body fs-body-150">-' + money(totalCents) + '</span>';

    var taxNote = footerInner.querySelector('.quick-cart__footer-tax-note');
    if (taxNote) footerInner.insertBefore(div, taxNote);
    else {
      var submit = footerInner.querySelector('.quick-cart__submit');
      if (submit) footerInner.insertBefore(div, submit);
      else footerInner.appendChild(div);
    }
  }

  // ── Головна функція ─────────────────────────────────────────────────────────

  function run() {
    var section = document.getElementById('shopify-section-quick-cart');
    if (!section) return;
    var footerInner = section.querySelector('.quick-cart__footer-inner');
    if (!footerInner) return;

    Promise.all([
      cachedConfig
        ? Promise.resolve(cachedConfig)
        : fetch(CONFIG_URL)
            .then(function (r) { return r.json(); })
            .then(function (d) { cachedConfig = d; return d; })
            .catch(function () { return { promotions: [] }; }),
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; }),
    ]).then(function (results) {
      var config    = results[0];
      var cartItems = (results[1] && results[1].items) || [];
      var promos    = (config && config.promotions) || [];

      var promoResult = null;
      for (var i = 0; i < promos.length; i++) {
        var r = calcPromo(promos[i], cartItems);
        if (r) { promoResult = r; break; }
      }

      updateSavingsRow(footerInner, promoResult);
    });
  }

  function debouncedRun() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 250);
  }

  // ── Спостерігачі ────────────────────────────────────────────────────────────

  function setupObservers() {
    var section = document.getElementById('shopify-section-quick-cart');
    if (!section) return;

    // Стежимо за змінами товарів у кошику (add/remove/qty)
    var itemsEl = section.querySelector('.quick-cart__items');
    if (itemsEl) {
      new MutationObserver(debouncedRun).observe(itemsEl, {
        childList: true, subtree: true, characterData: true,
      });
    }

    // Стежимо за відкриттям quick-cart (клас active/is-open)
    var cartEl = section.querySelector('.quick-cart');
    if (cartEl) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'class') { debouncedRun(); break; }
        }
      }).observe(cartEl, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // ── Ініціалізація ───────────────────────────────────────────────────────────

  function init() {
    setupObservers();
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
